import { jsx, jsxs } from "react/jsx-runtime";
import { Popover } from "@base-ui/react/popover";
import { Calendar } from "../Calendar/Calendar.js";
function DatePickerDesktop({ mode, open, handlePopOverOpenState, inputNode, title, selected, handleCalendarChange, components, collisionAvoidance, ...restProps }) {
    return /*#__PURE__*/ jsxs(Popover.Root, {
        open: open,
        onOpenChange: handlePopOverOpenState,
        children: [
            /*#__PURE__*/ jsx(Popover.Trigger, {
                render: inputNode
            }),
            /*#__PURE__*/ jsx(Popover.Portal, {
                children: /*#__PURE__*/ jsx(Popover.Positioner, {
                    sideOffset: 12,
                    align: "start",
                    collisionAvoidance: collisionAvoidance,
                    children: /*#__PURE__*/ jsxs(Popover.Popup, {
                        className: "origin-[var(--transform-origin)] rounded-xl bg-primary-1 p-4 shadow-overlay-md transition-[transform,scale,opacity] data-[ending-style]:scale-90 data-[ending-style]:opacity-0 data-[starting-style]:scale-90 data-[starting-style]:opacity-0",
                        children: [
                            /*#__PURE__*/ jsx(Popover.Arrow, {}),
                            /*#__PURE__*/ jsx(Popover.Title, {
                                className: "sr-only",
                                children: title
                            }),
                            /*#__PURE__*/ jsx(Calendar, {
                                ...restProps,
                                selected: selected,
                                handleCalendarChange: handleCalendarChange,
                                mode: mode,
                                components: components
                            })
                        ]
                    })
                })
            })
        ]
    });
}
export { DatePickerDesktop };
